import { EXTERNAL_URL } from '../../consts/asial-websites-sitemap.const';
import LogoRef from '../../resources/Asial-logo.svg';
import originalStyles from '../../styles/asial-website-footer.module.scss';
import React from 'react';
import { extractStyle } from '../../styles/styles-extract-util';

export const AsialWebsiteFooterCopyright: React.FC = () => {
  const styles = extractStyle(originalStyles);
  return (
    <div className={styles['footer-container']}>
      <a href={EXTERNAL_URL.ASIAL_HP}>
        <img src={LogoRef} alt="Asial logo footer" />
      </a>
      <span>COPYRIGHT ASIAL CORPORATION. ALL RIGHTS RESERVED.</span>
    </div>
  );
};
